import { render } from "./ProductSearchBox.vue?vue&type=template&id=1228a468"
import script from "./ProductSearchBox.vue?vue&type=script&lang=js"
export * from "./ProductSearchBox.vue?vue&type=script&lang=js"

import exportComponent from "D:\\gltech\\NewGrowthWebV2\\code\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__